import { Component, OnInit } from '@angular/core';
import { formatDate } from '@angular/common';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  currentYear: string;

  constructor() { }

  ngOnInit() {
    this.currentYear = formatDate(new Date(), 'yyyy', 'pt-BR');
  }

}
